import React, { useContext } from 'react'
import { faGripDotsVertical } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'antd'

import { RowContext } from '../Context/RowContext'

export const DragHandle = () => {
  const { setActivatorNodeRef, listeners, isFixed } = useContext(RowContext)

  return (
    <Button
      type={'link'}
      size={'small'}
      icon={<FontAwesomeIcon icon={faGripDotsVertical} size={'lg'} />}
      style={{
        cursor: isFixed ? 'not-allowed' : 'move',
        opacity: isFixed ? 0.5 : 1
      }}
      disabled={isFixed}
      ref={setActivatorNodeRef}
      {...listeners}
    />
  )
}
